class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    // ✅ Met à jour la barre livraison offerte à chaque affichage
    this.updateFreeShippingBar();

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  /* =========================
     Gengy : Free shipping bar
     ========================= */
  formatMoney(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        // Si ton thème a un formatMoney custom, il sera utilisé
        return window.Shopify.formatMoney(cents);
      }
    } catch (e) {}

    // fallback simple EUR
    const value = (cents / 100).toFixed(2).replace('.', ',');
    return `${value} €`;
  }

  async updateFreeShippingBar() {
    const THRESHOLD = 3000; // 30€ en centimes

    // ⚠️ Les éléments sont dans le snippet cart-notification
    const badge = document.getElementById('gg-free-ship-badge');
    const fill = document.getElementById('gg-free-ship-fill');
    const toast = document.getElementById('gg-free-ship-toast');

    if (!badge || !fill || !toast) return;

    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();

      const total = cart.total_price || 0;
      const remaining = Math.max(0, THRESHOLD - total);
      const progress = Math.min(100, Math.round((total * 100) / THRESHOLD));

      if (total < THRESHOLD) {
        badge.classList.remove('gg-free-ship__badge--ok');
        badge.textContent = `+ ${this.formatMoney(remaining)} pour l’obtenir`;
        fill.style.width = `${progress}%`;
      } else {
        badge.classList.add('gg-free-ship__badge--ok');
        badge.textContent = 'Activée';
        fill.style.width = '100%';
      }
    } catch (e) {
      // En cas d'erreur réseau, on ne casse rien
    }
  }
}

customElements.define('cart-notification', CartNotification);
